// src/utils/body-lock.js
var BodyLock = class {
  /**
   * lock the body to prevent scrolling.
   */
  lock() {
    const htmlElement = document.querySelector("html");
    htmlElement.setAttribute("data-lock", "true");
  }
  /**
   * unlock the scrolling of the body.
   */
  unlock() {
    const htmlElement = document.querySelector("html");
    htmlElement.setAttribute("data-lock", "false");
  }
};
var body_lock_default = new BodyLock();

// src/utils/cart-drawer.js
var cartDrawerElement = document.querySelector("#cart-drawer-holder");
var curtain = document.querySelector("#cart-curtain");
var cartDrawerOpener = document.querySelector(".cart-drawer-opener");
var closeDrawerOpener = document.querySelector(".close-cart-drawer");
var cartDrawer = class _cartDrawer {
  constructor() {
    if (cartDrawerElement) {
      if (cartDrawerOpener) {
        cartDrawerOpener.addEventListener("click", this.openCartDrawer);
      }
      if (closeDrawerOpener) {
        closeDrawerOpener.addEventListener("click", _cartDrawer.closeCartDrawer);
      }
    }
  }
  /**
   * Get current state of the cart drawer.
   *
   * @returns {{state: string, isCartOpen: boolean}}
   */
  getCurrentState() {
    if (cartDrawerElement.getAttribute("aria-hidden") === "false") {
      return {
        state: "open",
        isCartOpen: true
      };
    } else {
      return {
        state: "closed",
        isCartOpen: false
      };
    }
  }
  /**
   * Open cart drawer.
   */
  openCartDrawer() {
    cartDrawerElement.setAttribute("aria-hidden", "false");
    curtain.setAttribute("aria-hidden", "false");
    body_lock_default.lock();
  }
  /**
   * Close cart drawer.
   */
  static closeCartDrawer() {
    cartDrawerElement.setAttribute("aria-hidden", "true");
    curtain.setAttribute("aria-hidden", "true");
    body_lock_default.unlock();
  }
  /**
   * Handle open cart drawer.
   */
  handleOpenCartDrawer() {
    const currentState = this.getCurrentState();
    if (currentState.isCartOpen) {
      _cartDrawer.closeCartDrawer();
    } else {
      this.openCartDrawer();
    }
  }
  /**
   * Close the cart drawer when clicked outside the cart drawer.
   */
  static hideOnClickOutside() {
    const outsideClickListener = (event) => {
      const target = event.target;
      if (target !== cartDrawerElement && target.closest(".cart-drawer") || target.closest(".cart-drawer-opener") === cartDrawerOpener) {
      } else {
        this.closeCartDrawer();
        removeClickListener();
      }
    };
    const removeClickListener = () => {
      document.removeEventListener("click", outsideClickListener);
    };
    document.addEventListener("click", outsideClickListener);
  }
};
var cart_drawer_default = new cartDrawer();

// src/extenders/cart-drawer.js
var CartDrawer = class extends HTMLElement {
  constructor() {
    super();
    const close = this.querySelector("#cart-drawer-close");
    const curtain2 = document.querySelector("#cart-curtain");
    const toggle = document.querySelector("#cart-toggle");
    close == null ? void 0 : close.addEventListener("click", () => {
      cart_drawer_default.handleOpenCartDrawer();
    });
    curtain2 == null ? void 0 : curtain2.addEventListener("click", () => {
      cart_drawer_default.handleOpenCartDrawer();
    });
    toggle == null ? void 0 : toggle.addEventListener("click", () => {
      cart_drawer_default.handleOpenCartDrawer();
    });
  }
};
if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

// Add to cart form connector
document.addEventListener('DOMContentLoaded', function() {
  
  // Simple cart sections array (matching your existing structure)
  const cartSections = [
    "cart-header",
    "cart-items", 
    "cart-summary",
    "header"
  ];

  const addToCartForms = document.querySelectorAll('form.shopify-product-form[action="/cart/add"]');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault(); // Prevent normal form submission
      
      // Get the submit button to manage loading state
      const submitButton = form.querySelector('button[type="submit"]');
      
      // Set loading state
      if (submitButton) {
        submitButton.setAttribute('aria-busy', 'true');
        submitButton.disabled = true;
      }
      
      // Get variant ID
      const variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput || !variantIdInput.value) {
        console.error('No variant selected');
        if (submitButton) {
          submitButton.setAttribute('aria-busy', 'false');
          submitButton.disabled = false;
        }
        return;
      }

      // Make the add to cart request
      fetch("/cart/add.js", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantIdInput.value,
          quantity: 1,
          sections: cartSections.join(',')
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        // Update cart sections manually since we can't import handleChangeCart
        if (data.sections) {
          // Update cart drawer counter
          const drawerCounter = document.getElementById('cart-drawer-counter');
          if (drawerCounter && data.sections['cart-header']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data.sections['cart-header'], 'text/html');
            const newCounter = doc.getElementById('cart-drawer-counter');
            if (newCounter) {
              drawerCounter.textContent = newCounter.textContent;
            }
          }
          
          // Update header cart counter
          const headerCounter = document.getElementById('cart-item-counter');
          if (headerCounter && data.sections['header']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data.sections['header'], 'text/html');
            const newHeaderCounter = doc.getElementById('cart-item-counter');
            if (newHeaderCounter) {
              headerCounter.innerHTML = newHeaderCounter.innerHTML;
            }
          }
          
          // Update cart items
          const cartItems = document.getElementById('cart-items');
          if (cartItems && data.sections['cart-items']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data.sections['cart-items'], 'text/html');
            const newCartItems = doc.getElementById('cart-items');
            if (newCartItems) {
              cartItems.innerHTML = newCartItems.innerHTML;
            }
          }
          
          // Update cart summary
          const cartSummary = document.getElementById('cart-summary');
          if (cartSummary && data.sections['cart-summary']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data.sections['cart-summary'], 'text/html');
            const newCartSummary = doc.getElementById('cart-summary');
            if (newCartSummary) {
              cartSummary.innerHTML = newCartSummary.innerHTML;
            }
          }
        }
        
        // Open cart drawer using existing instance
        cart_drawer_default.handleOpenCartDrawer();
        
        // Show success feedback
        if (submitButton) {
          const originalText = submitButton.querySelector('span').textContent;
          submitButton.querySelector('span').textContent = 'Added to cart!';
          
          setTimeout(() => {
            submitButton.querySelector('span').textContent = originalText;
          }, 2000);
        }
      })
      .catch((error) => {
        console.error('Add to cart failed:', error);
        
        // Show error feedback
        if (submitButton) {
          const originalText = submitButton.querySelector('span').textContent;
          submitButton.querySelector('span').textContent = 'Error - try again';
          
          setTimeout(() => {
            submitButton.querySelector('span').textContent = originalText;
          }, 3000);
        }
      })
      .finally(() => {
        // Remove loading state
        if (submitButton) {
          setTimeout(() => {
            submitButton.setAttribute('aria-busy', 'false');
            submitButton.disabled = false;
          }, 500);
        }
      });
    });
  });
});
